import React, { Component } from "react";

export default class JSIntroduction extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}